<template>
  <SysDialog v-model="dialog_ativo" titulo="Selecione as colunas" :largura="800">
    <template #ativador>
      <SysBtn @click="dialog_ativo = true;">
        <v-icon class="mr-1" :size="18">mdi-view-column</v-icon>
        Colunas
      </SysBtn>
    </template>

    <div class="d-flex align-center">
      <div class="w-50-porcento">
        <Colunas v-model="colunas_selecionadas" :colunas="colunas" class="mr-2" />
      </div>

      <div class="w-50-porcento">
        <ColunasSelecionada v-model="colunas_selecionadas" class="mr-2" />
      </div>
    </div>

    <template #actions>
      <v-btn :disabled="colunas_selecionadas.length === 0" text color="primary" @click="salvarPreferenciasUsuario()">
        Salvar
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import SysDialog from "../../../../../padraoDeLayout/SysDialog.vue";
import {
  buscarListaColunasDiagnostico,
  salvarListaColunasGridSlowNoMovingDiagnostico
} from "../../../../../../api/Diagnostico/SlowNoMoving/IndicadorEvolucaoSlowNoMoving";
import {arrayColumn, logout} from "../../../../../../helpers";
import Colunas from "./Colunas.vue";
import ColunasSelecionada from "./ColunasSelecionada.vue";

export default {
  name: "ColunasTabela",
  components: {
    Colunas,
    ColunasSelecionada,
    SysDialog
  },
  data: () => ({
    dialog_ativo: false,
    colunas: [],
    colunas_selecionadas: [],
  }),
  mounted() {
    this.buscarListaColunasDiagnostico();
  },
  methods: {
    buscarListaColunasDiagnostico() {
      this.$store.dispatch("loading/addRequisicao",
        buscarListaColunasDiagnostico()
          .then(colunas => {
            this.colunas = colunas.todas_colunas;
            this.colunas_selecionadas = colunas.colunas_usuario;

            if (this.colunas_selecionadas.length > 0) {
              this.emitirEventoAtualizacaoColunas();
            } else {
              this.dialog_ativo = true;
            }
          })
          .catch(logout)
      );
    },
    emitirEventoAtualizacaoColunas() {
      this.$emit("update:colunas", this.colunas_selecionadas);
    },
    salvarPreferenciasUsuario() {
      this.dialog_ativo = false;
      this.emitirEventoAtualizacaoColunas();
      this.salvarListaColunasGridSlowNoMovingDiagnostico();
    },
    salvarListaColunasGridSlowNoMovingDiagnostico() {
      const colunas = arrayColumn(this.colunas_selecionadas, 'value');

      this.$store.dispatch("loading/addRequisicao",
        salvarListaColunasGridSlowNoMovingDiagnostico({colunas})
          .catch(logout)
      );
    },
  }
}
</script>

<style scoped>

</style>
